// extracted by mini-css-extract-plugin
export default {"label":"style_label__8kpZd","error":"style_error__MHDpI","input":"style_input__odoE9","select":"style_select__VoatT"};